// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'http://cityofstpetebeach-vendor.aclarian.com',
  appName: 'City of St. Pete Beach  | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pub37e5c72b6ba1726a15671a969b2f09d1',
  datadogApplicationId: '53f4651f-eb2e-40c7-9a36-97e99c81e7fc',
  datadogService: 'invoicing_stpetebeach_prod',
  ApiKey: 'Kf4$nRwX8@BJu5Y&',
  env: 'prod',
  version: packageInfo.version,
};
